import { addDays, differenceInCalendarDays, differenceInHours, eachMinuteOfInterval, endOfDay, setHours, startOfDay, startOfHour } from "date-fns";
import { Box, Text } from "grommet";
import { orderBy } from "lodash";
import * as React from "react";
import { CalendarViewEvent } from "./CalendarView";

const RenderAllDayEvents = ({ day, events }: { day: any; events: CalendarViewEvent[] }) => {
    const [currentDay, setCurrentDay] = React.useState(new Date());
    const [allDayEvents, setAllDayEvents] = React.useState([] as CalendarViewEvent[]);

    React.useEffect(() => {
        getCurrentDay();
    }, [day]);

    React.useEffect(() => {
        getDayEvents();
    }, [currentDay]);

    const getCurrentDay = () => {
        if (!isNaN(day)) {
            setCurrentDay(new Date(day));
        }
    };

    const getDayEvents = () => {
        let newArray = [] as CalendarViewEvent[];
        let tempEvents = orderBy(events, "start") as CalendarViewEvent[];

        if (tempEvents.length > 0) {
            tempEvents.forEach((event) => {
                let days = differenceInCalendarDays(event.end, event.start);
                for (let i = 0; i <= days; i++) {
                    let tempEvent = { ...event };
                    tempEvent.start = addDays(tempEvent.start, i);

                    tempEvent.start = startOfHour(tempEvent.start);
                    tempEvent.duration = differenceInHours(tempEvent.end, tempEvent.start).toString();

                    if (tempEvent.start >= startOfDay(currentDay) && tempEvent.start <= endOfDay(currentDay)) {
                        newArray = [...newArray, tempEvent];
                    }
                }
            });

            setAllDayEvents(newArray.filter((event) => event.allDay));
        }
    };

    return (
        <Box>
            {allDayEvents.length > 0 && (
                <>
                    <Text weight="bold">All Day Events</Text>
                    <Box>
                        {allDayEvents.map((event) => (
                            <Text key={event.id} color={event.color}>
                                {event.title}
                            </Text>
                        ))}
                    </Box>
                </>
            )}
        </Box>
    );
};

export default RenderAllDayEvents;
